import React, {useEffect, useState} from "react";
import restService from "../../../services/restService";
import {Link} from "react-router-dom";
import tableData from "../../../assets/static_json/transactionTable.json";
import TransactionStyles from "./styles";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import {useSelector} from "react-redux";
import Search from "../../../components/common/Search";

import {downloadFile} from "@/helpers/fileUtils.js";
import AdminTransactionFilterModal from "./AdminTransactionFilterModal";
import {Empty, Pagination} from "antd";
import Pusher from "pusher-js";
import Modal from "../../../components/common/Modal";
import Table2 from "../../../components/common/Table/Table2";
import SkeletonElement from "../../../components/Skeletons/SkeletonElement";
import PaginationComponent from "../../../components/common/Pagination";


import moment from "moment";


const head = tableData.adminHeadData;
const Transact = () => {
  const staffId = useSelector((state) => state?.auth?.user?.id);
  const staff = useSelector((state) => state?.auth?.user);

  const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [transactionStatuses, setTransactionStatuses] = useState([]);
  const [pageTo, setPageTo] = useState(0);
  const [from, setFrom] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [status, setTransactionStatus] = useState(5);
  const [totalEntries, setTotalEntries] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [activeFilters, setActiveFilters] = useState({});
  const [hasActiveModalFilters, setHasActiveModalFilters] = useState(false);
  const [pusherChannel, setPusherChannel] = useState(null);
  const [pusherChannel2, setPusherChannel2] = useState(null);
  const [transactionToAccept, setTransactionToAccept] = useState(undefined);
  const [paginateDateFilter, setPaginateDateFilter] = useState(false);
  const [transactionToReject, setTransactionToReject] = useState(undefined);
  const [rejectAcknowledge, setRejectAcknowledge] = useState(false);
  const [rejectError, setRejectError] = useState("");

  const updateTransaction = () => {
    setLoading(true);
    restService.TransactionsApi.updateTransactionStatus(
        transactionToAccept.id,
        transactionToAccept?.transaction_status.status === "Accepted" ?
            getTransactionStatusId("Dispatched") :
        transactionToAccept?.transaction_status.status === "Success" ?
            getTransactionStatusId("Reversed") :
        status,
        staffId
    )
      .then(() => {
        if (hasActiveModalFilters || paginateDateFilter) {
          fetchTransactionsWithFilters(currentPage);
        } else {
          fetchTransactions(currentPage);
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        setTransactionToAccept(undefined);
      });
  };

  // Reject transaction by setting status id 7 via status-change API
  const rejectTransaction = () => {
    if (!transactionToReject) return;
    setLoading(true);
    restService.TransactionsApi.updateTransactionStatus(
      transactionToReject.id,
      7,
      staffId
    )
      .then(() => {
        if (hasActiveModalFilters || paginateDateFilter) {
          fetchTransactionsWithFilters(currentPage);
        } else {
          fetchTransactions(currentPage);
        }
      })
      .finally(() => {
        setLoading(false);
        setTransactionToReject(undefined);
      });
  };

  const getTransactionStatusId = (status) => {
   return  transactionStatuses.find(transaction => transaction.status === status)?.id;
  }

  const showUpdateButton = (transaction) => {
    if (transaction?.partner_id !== 1) return false;
    if (staff?.staff_role?.id !== 5) return false;

    if (transaction?.transaction_status?.status === "Dispatched" || transaction?.transaction_status?.status === "Success") {
      if (staffId === transaction?.staff_id) return true;
    }

    if (transaction?.transaction_status?.status === "Accepted") return true;
    if (transaction?.transaction_status?.status === "Created") return true; // allow actions on Created

    return false;
  }

  // Show Reject button when status is Accepted or Created
  const showRejectButton = (transaction) => {
    // if (transaction?.partner_id !== 1) return false;
    if (staff?.staff_role?.id !== 3) return false;
    const st = transaction?.transaction_status?.status;
    return st === "Accepted" || st === "Created";
  }

  const onStatusChange = ({target}) => {
    setTransactionStatus(target.value);
  }

  const fetchTransactions = (page) => {
    page = page -1;
    setLoading(true);
    restService.TransactionsApi.getTransactions(page)
        .then((response) => {
          if (response) {
            setPageTo(response.data?.data?.to);
            setTotalEntries(response.data?.data?.total);
            setTransactions(response.data?.data?.data);
            setFrom(response.data?.data?.from);
          }
        })
        .finally(() => {
          setLoading(false);
        });
  };

  useEffect(() => {
    fetchTransactions();
    restService.UtilsApi.getTransactionStatuses().then(({data}) => {
      setTransactionStatuses(data?.data)
    });
    const pusher = new Pusher(
        import.meta.env.VITE_API_ENVIRONMENT === "dev"
            ? import.meta.env.VITE_PUSHER_KEY_DEVELOPMENT:
            import.meta.env.VITE_API_ENVIRONMENT === "staging" ?
                import.meta.env.VITE_PUSHER_KEY_STAGING
                : import.meta.env.VITE_PUSHER_KEY_PRODUCTION,
        {
          cluster: "eu",
          forceTLS: true,
        }
    );
    const channel = pusher.subscribe(`general-transactions-created`);
    setPusherChannel(channel);

    const channel2 = pusher.subscribe(`general-transactions-updated`);
    setPusherChannel2(channel2);
  }, []);

  useEffect(() => {
    if (
        pusherChannel &&
        pusherChannel.bind &&
        pusherChannel2 &&
        pusherChannel2.bind
    ) {
      pusherChannel.unbind("transaction-created");
      pusherChannel2.unbind("transaction-update");
      pusherChannel.bind("transaction-created", function (data) {
        let list = [...transactions];
        list.unshift(data.message);
        setTransactions(list);
      });
      pusherChannel2.bind("transaction-update", function (data) {
        if (transactions?.length > 0) {
          let index = transactions.findIndex((trans) => {
            // console.log(data?.message?.id)
            // console.log(trans)
            return trans.id === data?.message?.id;
          });

          if (index >= 0) {
            transactions[index] = data.message;
            setTransactions([...transactions]);
          }
        }
      });
    }
  }, [pusherChannel, pusherChannel2, transactions]);

  const [fromSortModal, setFromSortModal] = useState(false);



  const clearFilters = () => {
    setActiveFilters({});
    setHasActiveModalFilters(false);
    setShowModal(false);
    setFromSortModal(false);
    setPaginateDateFilter(false);
    setCurrentPage(1);
    
    fetchTransactions(1);
  };

  const fetchTransactionsWithFilters = (page = 1, filters = null) => {
    setLoading(true);
    
    // Use provided filters or fall back to activeFilters
    const currentFilters = filters || activeFilters;
    
    // Add page parameter to the filters
    const filtersWithPage = {
      ...currentFilters,
      page: page - 1 // API expects 0-based page index
    };

    console.log("fetchTransactionsWithFilters - currentFilters:", currentFilters);
    console.log("fetchTransactionsWithFilters - filtersWithPage:", filtersWithPage);
    
    restService.TransactionsApi.getTransactionsByFilters(filtersWithPage)
      .then((response) => {
        setPageTo(response.data?.data?.to);
        setTotalEntries(response.data?.data?.total);
        setTransactions(response.data?.data?.data);
        setFrom(response.data?.data?.from);
        setFromSortModal(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const applyFilter = (filters) => {
    console.log("applyFilter called with:", filters);
    setShowModal(false);
    setLoading(true);
    setFromSortModal(true);
    setActiveFilters(filters);
    setCurrentPage(1);
    
    const hasFilters = Object.keys(filters).length > 0;
    setHasActiveModalFilters(hasFilters);
    
    // Determine if this is a date-only filter
    const isDateOnlyFilter = hasFilters && 
      (filters.start_date || filters.end_date || filters.date) &&
      Object.keys(filters).every(key => 
        ['start_date', 'end_date', 'date'].includes(key)
      );
    
    setPaginateDateFilter(isDateOnlyFilter);

    // Pass filters directly to avoid state timing issues
    fetchTransactionsWithFilters(1, filters);
  };

  const exportTransactions = () => {
    let headers = [
      "ID,Sender,Receiver,Send Amount,Receive Amount,Charge,Status,Date",
    ];

    let transactionCsv = transactions.reduce((acc, transaction) => {
      const {
        id,
        sender: {firstname: senderFirstName, lastname: senderLastName},
        receiver: {firstname: receiverFirstName, lastname: receiverLastName},
        send_amount,
        source_currency,
        destination_currency,
        receive_amount,
        charge,
        transaction_status: {status},
        created_at,
      } = transaction;
      acc.push(
          [
            id,
            `${senderFirstName} ${senderLastName}`,
            `${receiverFirstName} ${receiverLastName}`,
            `${source_currency}${send_amount}`,
            `${destination_currency}${receive_amount}`,
            `${source_currency}${charge}`,
            status,
            moment(new Date(created_at)).format("MMMM DD YYYY"),
          ].join(",")
      );
      return acc;
    }, []);

    downloadFile({
      data: [...headers, ...transactionCsv].join("\n"),
      fileName: `Transaction-${moment().format("YYYY-MM-DD-H-m-s")}.csv`,
      fileType: "text/csv",
    });
  };

  const searchTransactionByInput = async (input) => {
    // Clear all filters when searching
    setActiveFilters({});
    setHasActiveModalFilters(false);
    setPaginateDateFilter(false);
    setCurrentPage(1);
    
    if (!input || input.trim() === "") {
      // If search is empty, fetch default transactions
      fetchTransactions(1);
      return;
    }
    
    setLoading(true);
    try {
      // Use the filters API with search term
      const filters = {
        search: input.trim(),
        page: 0
      };
      
      const response = await restService.TransactionsApi.getTransactionsByFilters(filters);
      const transactionData = response?.data?.data;
      
      setPageTo(transactionData?.to);
      setTotalEntries(transactionData?.total);
      setTransactions(transactionData?.data || []);
      setFrom(transactionData?.from);
    } catch (error) {
      console.error("Search failed:", error);
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  const pageChange = (page) => {
    setCurrentPage(page);
    if (hasActiveModalFilters || paginateDateFilter) {
      // Use modal filters for pagination (including date filters)
      fetchTransactionsWithFilters(page);
    } else {
      // Use default pagination
      fetchTransactions(page);
    }
  };

  const [selectedTransactions, setSelectedTransactions] = useState([]);



  return (
      <div className="mt-13-important">
        <TransactionStyles>
          <PageTitle title={`Transactions History`} />

          <div className="content-layout ">

            <div className="header-layout gap-2">
              <div className="flex md:items-center w-full gap-2 md:flex-row flex-col ">
                <Search
                    placeholder={"Search Transaction"}
                    onChange={(e) => searchTransactionByInput(e.target.value)}
                />
              </div>

              <div className="intro-y flex flex-col-reverse w-full justify-end sm:flex-row md:items-center">
                <div className="intro-y gap-4 flex justify-end md:justify-end sm:flex-row items-center md:mr-3">
                  <button
                      onClick={(e) => {
                        setShowModal(true);
                      }}
                      className="btn btn-secondary flex items-center gap-2 relative"
                  >
                  <span>
                    <svg
                        width="13"
                        height="9"
                        viewBox="0 0 13 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M0.312988 0.919434H12.313V2.3312H0.312988V0.919434ZM2.31299 4.21355H10.313V5.62532H2.31299V4.21355ZM4.71299 7.50767H7.91299V8.91943H4.71299V7.50767Z"
                          fill="#0042C6"
                      />
                    </svg>
                  </span>
                    <span>Filter</span>
                    {Object.keys(activeFilters).length > 0 && (
                      <span className="absolute -top-2 -right-2 bg-blue-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                        {Object.keys(activeFilters).length}
                      </span>
                    )}
                  </button>

                  {/* Clear Filters Button - Show when there are active filters */}
                  {Object.keys(activeFilters).length > 0 && (
                    <button
                        onClick={clearFilters}
                        className="btn btn-outline-secondary flex items-center gap-2 text-xs"
                    >
                      <span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="3,6 5,6 21,6"></polyline>
                          <path d="M19,6v14a2,2 0 0,1-2,2H7a2,2 0 0,1-2-2V6m3,0V4a2,2 0 0,1,2-2h4a2,2 0 0,1,2,2v2"></path>
                        </svg>
                      </span>
                      Clear Filters
                    </button>
                  )}

                  <button
                      className="btn btn-primary-2  flex items-center gap-2 text-xs"
                      onClick={exportTransactions}
                  >
                  <span>
                    <svg
                        width="9"
                        height="11"
                        viewBox="0 0 9 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M1.77902 4.4763C1.63547 4.4763 1.4978 4.53332 1.3963 4.63482C1.2948 4.73633 1.23777 4.87399 1.23777 5.01754V9.70832C1.23777 9.85187 1.2948 9.98954 1.3963 10.091C1.4978 10.1925 1.63547 10.2496 1.77902 10.2496H7.19146C7.33501 10.2496 7.47267 10.1925 7.57418 10.091C7.67568 9.98954 7.7327 9.85187 7.7327 9.70832V5.01754C7.7327 4.87399 7.67568 4.73633 7.57418 4.63482C7.47267 4.53332 7.33501 4.4763 7.19146 4.4763H6.28939C6.0901 4.4763 5.92856 4.31475 5.92856 4.11547C5.92856 3.91619 6.0901 3.75464 6.28939 3.75464H7.19146C7.5264 3.75464 7.84763 3.88769 8.08447 4.12453C8.32131 4.36137 8.45436 4.6826 8.45436 5.01754V9.70832C8.45436 10.0433 8.32131 10.3645 8.08447 10.6013C7.84763 10.8382 7.5264 10.9712 7.19146 10.9712H1.77902C1.44407 10.9712 1.12285 10.8382 0.886009 10.6013C0.649169 10.3645 0.516113 10.0433 0.516113 9.70832V5.01754C0.516113 4.6826 0.649169 4.36137 0.886009 4.12453C1.12285 3.88769 1.44407 3.75464 1.77902 3.75464H2.68109C2.88037 3.75464 3.04192 3.91619 3.04192 4.11547C3.04192 4.31475 2.88037 4.4763 2.68109 4.4763H1.77902Z"
                          fill="white"
                      />
                      <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.84613 0.86792C5.04541 0.86792 5.20696 1.02178 5.20696 1.21157V6.91122L6.39513 5.77963C6.53604 5.64543 6.76451 5.64543 6.90542 5.77963C7.04633 5.91383 7.04633 6.13142 6.90542 6.26562L5.10127 7.98386C4.96036 8.11806 4.7319 8.11806 4.59098 7.98386L2.78684 6.26562C2.64592 6.13142 2.64592 5.91383 2.78684 5.77963C2.92775 5.64543 3.15621 5.64543 3.29713 5.77963L4.4853 6.91122V1.21157C4.4853 1.02178 4.64685 0.86792 4.84613 0.86792Z"
                          fill="white"
                      />
                    </svg>
                  </span>

                    <span>Export CSV </span>
                  </button>
                </div>
              </div>
            </div>

            {showModal && (
                <AdminTransactionFilterModal
                    visible={showModal}
                    onCreate={applyFilter}
                    onCancel={() => {
                      setShowModal(false);
                    }}
                    onClearFilters={clearFilters}
                    loading={loading}
                    initialFilters={activeFilters}
                />
            )}

            <div className="header-layout gap-2">
              {!loading ? (
                  <div className="flex w-full flex-col">
                    <Table2
                        tHead={
                          <>
                            {/* Checkbox column removed as requested */}
                            <th className="">Sender</th>
                            <th className="">Recipient</th>
                            <th className="">Transaction ID</th>
                            <th className="">Amount Sent</th>
                            <th className="">Date</th>
                            <th className="">Partner</th>
                            <th className="text-center">Status</th>
                            <th className=""></th>
                          </>
                        }
                    >
                      {transactions.map((item, index) => (
                          <tr key={index} className="">
                            {/* Row checkbox removed as requested */}
                            <td>
                              <Link
                                  to={`/sender/${item?.sender?.id}`}
                                  className="flex items-center gap-2"
                              >
                           <span>
                          {item?.sender?.profile_image ?

                              <img
                                  src={item?.sender?.profile_image}
                                  alt=""
                                  className="w-[30px] h-[30px] object-cover rounded-full"
                              />
                              :
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                   fill="none" stroke="currentColor" stroke-width="2" strokeLinecap="round"
                                   strokeLinejoin="round" className="feather feather-user">
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                              </svg>
                          }
                          </span>

                                <span className="text-black font-medium whitespace-nowrap">
                            {`${item?.sender?.firstname} ${item?.sender?.lastname}`}
                          </span>
                              </Link>
                            </td>
                            <td>
                              <Link
                                  to={`/receiver/${item?.receiver?.id}`}
                                  className="whitespace-nowrap"
                              >
                                {`${item?.receiver?.firstname} ${item?.receiver?.lastname}`}
                              </Link>
                            </td>
                            <td>
                              <p className="">{item.id}</p>
                            </td>

                            <td>
                              <p className="font-medium whitespace-nowrap text-black">
                                {" "}
                                {item.source_currency} {item.send_amount}
                              </p>
                            </td>
                            <td>
                              <p className="whitespace-nowrap">
                                {moment(new Date(item.created_at)).format(
                                    "MMMM DD, YYYY"
                                )}
                              </p>
                            </td>
                            <td>
                              <p className="">{item?.partner?.name}</p>
                            </td>
                            <td>
                              <p
                                  className={`rounded-[100px] status-${item?.transaction_status?.status?.toLowerCase()} text-center px-2 py-1.5`}
                              >
                                {item?.transaction_status?.status}
                              </p>
                            </td>
                            <td>

                              <div className="flex items-center gap-3">
                                {/* Primary action(s) first: Update/Edit */}
                                {showUpdateButton(item) && (
                                  <button
                                    className="p-1 rounded hover:bg-gray-100"
                                    onClick={() => setTransactionToAccept(item)}
                                    title="Update Status"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-edit-3">
                                      <path d="M12 20h9"></path>
                                      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                                    </svg>
                                  </button>
                                )}

                                {/* Reject as icon-only destructive action */}
                                {showRejectButton(item) && (
                                  <button
                                    className="p-1 rounded hover:bg-red-50 text-red-600"
                                    onClick={() => setTransactionToReject(item)}
                                    title="Reject Transaction"
                                  >
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line x1="15" y1="9" x2="9" y2="15"></line>
                                      <line x1="9" y1="9" x2="15" y2="15"></line>
                                    </svg>
                                  </button>
                                )}

                                {/* Receipt moved to the end */}
                                <div className="ml-auto zoom-in">
                                  <Link to={`/transaction/${item.id}`} className="inline-flex items-center gap-1 text-blue-600 hover:underline">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-file-text">
                                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                      <polyline points="14 2 14 8 20 8"></polyline>
                                      <line x1="16" y1="13" x2="8" y2="13"></line>
                                      <line x1="16" y1="17" x2="8" y2="17"></line>
                                      <polyline points="10 9 9 9 8 9"></polyline>
                                    </svg>
                                    <span>Receipt</span>
                                  </Link>
                                </div>
                              </div>
                            </td>
                          </tr>
                      ))}
                    </Table2>

                    {transactions.length < 1 && (
                        <div className="flex items-center justify-center h-[30vh]">
                          <Empty/>
                        </div>
                    )}
                  </div>
              ) : (
                  <div className="flex w-full flex-col">
                    <Table2
                        headData={head}
                        tHead={
                          <>
                            {/* Skeleton checkbox column removed as requested */}
                            <th className="">Sender</th>
                            <th className="">Recipient</th>
                            <th className="">Transaction ID</th>
                            <th className="">Amount Sent</th>
                            <th className="">Status</th>
                            <th className=""></th>
                          </>
                        }
                    >
                      {Array(5)
                          .fill()
                          .map((item, index) => (
                              <tr key={index}>
                                {Array(7)
                                    .fill()
                                    .map((x, i) => (
                                        <td key={i}>
                                          <SkeletonElement type={"title"} />
                                        </td>
                                    ))}
                              </tr>
                          ))}
                    </Table2>
                  </div>
              )}
            </div>
          </div>


          <div className="flex flex-col mb-[10vh] px-5 gap-4 justify-between md:items-center md:flex-row mt-8">
            <div className="page text-[#999999] text-xs">
              {loading
                  ? ""
                  : transactions && transactions.length <= 0
                      ? "No Transactions Found"
                      : `Showing  ${pageTo} out of ${totalEntries} results`}
            </div>

            <div className="mt-3  flex justify-end float-right">
              <PaginationComponent
                  current={currentPage}
                  defaultCurrent={currentPage}
                  showSizeChanger={false}
                  onChange={pageChange}
                  total={totalEntries}
              />
            </div>
          </div>

          {transactionToAccept && (
              <Modal
                  onClick={updateTransaction}
                  modalTitle={transactionToAccept?.transaction_status.status === "Accepted" ?
                      "Dispatch Transaction": transactionToAccept?.transaction_status.status === "Success" ? "Reverse Transaction" : "Update Transaction Status"}
                  buttonTitle={transactionToAccept?.transaction_status.status === "Accepted" ? "Dispatch" : transactionToAccept?.transaction_status.status === "Success" ? "Reverse": "Update"}
                  buttonColor={transactionToAccept?.transaction_status.status === "Accepted" ? "bg-blue-600" : transactionToAccept?.transaction_status.status === "Success" ? "bg-red-600" : "bg-blue-600"}
                  size="small"
                  body={
                    transactionToAccept?.transaction_status.status === "Accepted" ?
                        <p className="text-sm text-gray-500">
                          Are you sure you want to dispatch this transaction?
                        </p>
                        : transactionToAccept?.transaction_status.status === "Success" ?
                            <p className="text-sm text-gray-500">
                              Are you sure you want to reverse this transaction?
                            </p>
                            :
                        <>
                            <p className="text-sm text-gray-500">
                              Select New Status
                            </p>
                            <form>
                              <div className="mt-4">
                                <label className="block text-sm font-medium text-gray-700">
                                  Update Status
                                </label>
                                <select
                                    onChange={onStatusChange}
                                    name="status"
                                    className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                    defaultValue="Success"
                                >
                                  <option value={getTransactionStatusId("Success")}>Success</option>
                                  <option value={getTransactionStatusId("Error")}>Error</option>
                                </select>
                              </div>
                            </form>
                        </>
                  }
                  onClose={() => {
                    setTransactionToAccept(undefined);
                  }}
              />
          )}

          {transactionToReject && (
            <Modal
              onClick={() => {
                if (!rejectAcknowledge) {
                  setRejectError("Please acknowledge this action cannot be undone.");
                  return;
                }
                setRejectError("");
                rejectTransaction();
              }}
              modalTitle={"Reject Transaction"}
              buttonTitle={"Confirm Reject"}
              buttonColor={"bg-red-600"}
              size="small"
              body={
                <div className="space-y-3">
                  <p className="text-sm text-gray-600">
                    This will set the status to <span className="font-semibold">Error</span>.
                  </p>
                  <div className="bg-red-50 border border-red-200 text-red-700 p-2 rounded text-xs">
                    This action cannot be undone.
                  </div>
                  <label className="inline-flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      checked={rejectAcknowledge}
                      onChange={(e) => {
                        setRejectAcknowledge(e.target.checked);
                        if (rejectError) setRejectError("");
                      }}
                    />
                    <span>I understand this cannot be undone</span>
                  </label>
                  {rejectError && (
                    <p className="text-xs text-red-600">{rejectError}</p>
                  )}
                </div>
              }
              onClose={() => {
                setTransactionToReject(undefined);
                setRejectAcknowledge(false);
                setRejectError("");
              }}
            />
          )}
        </TransactionStyles>
      </div>
  );
};

export default Transact;
